<template lang="pug">
    div
        Button(shape="circle" icon="md-help" size="small"  @click="instance(true)" )
    </template>
<script>
export default {
    name: "ExplainArgsRewrite",
    props: {},
    data() {
        return {};
    },
    methods: {
        instance(scrollable) {
            this.$Modal.info({
                width: "800px",
                title: "Example",
                content: `
                        <h2>應用場景[基礎]: 源站API版本更新，需要將Args路徑version=a更改為<span style="color: green">version=b</span>。</h2>
                        <h3>設置規則</h3>
                        <ul style="padding-left: 40px;">
                            <li><input type="checkbox" disabled>迭代:  <span>^\\version=a</span> -> <span>version=b</span></li>
                        </ul>
    
                        <br>
                        <h3>請求路徑(ㄧ): /api/v1/domains?version=a</h3>
                        <ul style="padding-left: 40px;">
                            <li>命中第一條規則，進行URL改寫。</li>
                        </ul>
                        <p>
                            <span style="background-color: #FFFF00">
                                最終改寫結果: <span>/api/v1/domains?<strong style="color: green">version=b</strong></span>
                            </span>
                        </p>
    
                        <br>
                        <br>
                        
                        <h2>應用場景[進階]: 承上，使用多條配置實現更靈活地改寫。</h2>
                        <h3>設置規則</h3>
                        <ul style="padding-left: 40px;">
                            <li><input type="checkbox" disabled checked>迭代:  <span>^\\version=a</span> -> <span>version=b</span></li>
                            <li><input type="checkbox" disabled >迭代:  <span>servername -> domains</span></li>
                            <li><input type="checkbox" disabled >迭代:  <span>pems</span> -> <span>certs</span></li>
                        </ul>
    
                        <h3>請求路徑(ㄧ): /api/v1/servername?version=a&servername=a.b.com&pems=a.b.comcert</h3>
                        <ul style="padding-left: 40px;">
                            <li>命中第一條規則，改寫為 <span>/api/v1/servername?<strong style="color: green">version=b</strong>&servername=a.b.com&pems=a.b.comcert</span>
                            <br>
                            第一條規則啟用迭代，繼續檢查第二條規則。</li> 
                            <li>命中第二條規則，改寫為 <span>/api/v1/servername?version=b&<strong style="color: green">domains</strong>=a.b.com&pems=a.b.comcert</span>
                            <br>
                            第二條規則未啟用迭代，不再檢查後續規則。</li> 
                        </ul>
                        <p>
                            <span style="background-color: #FFFF00">
                                最終改寫結果: <span>/api/v1/servername?<strong style="color: green">version=b</strong><span>&</span><strong style="color: green">domains</strong>=a.b.com&pems=a.b.comcert</span>
                            </span>
                        </p>
                        <br>
    
                        <h3>請求路徑(二): /api/v2/servername?servername=a.b.com&pems=a.b.comcert</h3>
                        <ul style="padding-left: 40px;">
                            <li>未命中第一條規則。</li>
                            <li>命中第二條規則，改寫為 <span>/api/v2/servername?<strong style="color: green">domains</strong>=a.b.com&pems=a.b.comcert</span>
                            <br>
                            未啟用迭代，後續規則不再檢查。</li>
                        </ul>
                        <p>
                            <span style="background-color: #FFFF00">
                                最終改寫結果: <span>/api/v2/servername?<strong style="color: green">domains</strong>=a.b.com&pems=a.b.comcert</span>
                            </span>
                        </p>
                        <br>
    
                        <h3>請求路徑(三): /api/v2/servername?pems=a.b.comcert</h3>
                        <ul style="padding-left: 40px;">
                            <li>未命中第一條規則。</li>
                            <li>未命中第二條規則。</li>
                            <li>命中第三條規則，改寫為 <span>/api/v2/servername?<strong style="color: green">certs</strong>=a.b.comcert</span></li>
                        </ul>
                        <p>
                            <span style="background-color: #FFFF00">
                                最終改寫結果: <span>/api/v2/servername?<strong style="color: green">certs</strong>=a.b.comcert</span>
                            </span>
                        </p>
                        
                    `,
                // scrollable: scrollable,
            });
        },
    },
    computed: {},
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/PoptipInfos/ExplainArgsRewrite.vue